import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { useQuery } from '~/client/hooks/cqrpc'
import { useCurrentUser } from '~/client/hooks/auth'
import ErrorMessage from '~/client/components/ErrorMessage'
import Heading from '~/client/components/Heading'
import SideNote from '~/client/components/SideNote'
import Timestamp from '~/client/components/Timestamp'
import AppIconAndName from '~/client/components/AppIconAndName'

export default function AppAccountsPage() {
  const query = useQuery('appAccounts.getMine')
  return <Container>
    <Heading my={2} variant="main">Accounts</Heading>
    <SideNote>
      Accounts are the individual data sharing relationships
      that you have put in place with different applications
      and organisations.
    </SideNote>
    <ErrorMessage error={query.error}/>
    <AppAccountsTable
      appAccounts={query.result || []}
      loading={query.loading}
    />
  </Container>
}

function AppAccountsTable({ appAccounts, loading }){
  const { currentUser } = useCurrentUser()
  return <TableContainer sx={{}}>
    <Table aria-label="simple table">
      <TableHead>
        <TableRow>
          {/*<TableCell>Nickname</TableCell>*/}
          <TableCell>App</TableCell>
          <TableCell>Created At</TableCell>
          <TableCell>Last Used</TableCell>
        </TableRow>
      </TableHead>
      <TableBody sx={{
        '&:last-child td, &:last-child th': {
          border: 0
        }
      }}>
        {loading
          ? <TableRow>
            <TableCell colSpan={4}>
              Loading…
            </TableCell>
          </TableRow>
          : appAccounts.map(appAccount =>
            <AppAccountsTableRow key={appAccount.id} {...{currentUser, appAccount}}/>
          )
        }
      </TableBody>
    </Table>
  </TableContainer>
}

function AppAccountsTableRow({ appAccount }){
  return <TableRow>
    {/*<TableCell>*/}
    {/*  /!*<AppAccountAvatarAndDisplayName {...{ appAccount }}/>*!/*/}
    {/*  {appAccount.nickname}*/}
    {/*</TableCell>*/}
    <TableCell>
      <AppIconAndName app={appAccount.app} to={`/accounts/${appAccount.id}`}/>
    </TableCell>
    <TableCell>
      <Timestamp at={appAccount.createdAt} sx={{whiteSpace: 'nowrap'}}/>
    </TableCell>
    <TableCell>
      <Timestamp at={appAccount.lastUsedAt} sx={{whiteSpace: 'nowrap'}}/>
    </TableCell>
  </TableRow>
}
